@if (monitoringConfigs) {
    <div class="agpr-monitoring-preferences">
        <!-- Sub headings
        - Content Providers (Media & Broadcast)
        - Topics
        - Alerts (TO DO)
        - Subscriptions
        - Prominence
        - Mention Importing (TO DO)
        -->
        @if (hasMonitoring) {
            <agpr-providers-preferences
                [displayFinancialTimesPodcastUpsell]="displayFinancialTimesPodcastUpsell"
                (licensesChanged)="handleLicenseChange()"
            ></agpr-providers-preferences>
            <agpr-broadcast-preferences
                (licensesChanged)="handleLicenseChange()"
            ></agpr-broadcast-preferences>
        }

        <!-- Topics -->
        <agpr-panel
            header="AMT.monitoring.topics"
            [paddingBottom]="0"
            [marginTop]="20"
        >
            <div class="agpr-columns">
                <div class="agpr-column">
                    <agpr-number-input
                        id="taggingSearchLimit.input"
                        [(ngModel)]="monitoringConfigs.taggingSearchLimit"
                        [disabled]="isReadOnly"
                        label="AMT.monitoring.topicsThatTag"
                        tooltip="AMT.monitoring.topicsThatTag.tooltip"
                        [integerOnly]="true"
                        [min]="0"
                        [max]="100"
                    ></agpr-number-input>
                </div>
            </div>
            <ng-container>
                <agpr-checkbox
                    id="monitoringPreferences_autoSaving_checkbox"
                    label="AMT.monitoring.autoSaving.checkbox"
                    infoCircleTooltip="AMT.monitoring.autoSaving.checkbox.tooltip"
                    [binary]="true"
                    [(ngModel)]="enableAutoSavingTopic"
                    (ngModelChange)="toggleAutoSavingTopic()"
                ></agpr-checkbox>
                <div class="agpr-columns agpr-monitoring-preferences-autoSaving-input">
                    @if (enableAutoSavingTopic) {
                        <agpr-number-input
                            id="autoSaveTopicLimit.input"
                            aria-describedby="autoSaveLimit_error"
                            [(ngModel)]="monitoringConfigs.autoSaveTopicLimit"
                            (blur)="checkAutoSaveLimit()"
                            [disabled]="isReadOnly"
                            label="AMT.monitoring.autoSaving.limit"
                            [tooltip]="'AMT.monitoring.autoSaving.limit.tooltip' | localize : { max: maxAutoSavingLimit}"
                            [integerOnly]="true"
                            [defaultValue]="5"
                            [min]="0"
                            [max]="100"
                        ></agpr-number-input>
                    }
                </div>
                @if (autoSavingTopicErrorMessage && enableAutoSavingTopic) {
                    <agpr-form-message id="autoSaveLimit_error">
                        {{ autoSavingTopicErrorMessage }}
                    </agpr-form-message>
                }
            </ng-container>
        </agpr-panel>

        <!-- TODO Alerts Settings -->

        <agpr-panel
            header="AMT.subscriptions"
            [paddingBottom]="0"
            [marginTop]="20"
        >
            <agpr-checkbox
                id="monitoringPreferences_subscriptions_checkbox"
                label="Core.navigation.mediaIntelligence.subscriptions"
                [binary]="true"
                [disabled]="disableInputs || monitoringConfigs.licenses[licensesEnum.TVEYES] || lockSubscriptions"
                [(ngModel)]="hasSubscriptions"
                (ngModelChange)="toggleAllSubscriptions($event)"
            >
                @if (monitoringConfigs.licenses[licensesEnum.TVEYES] || lockSubscriptions) {
                    <span
                        class="agpr-mentionLinks-info fa-regular fa-circle-info"
                        agprTooltip="AMT.subscriptions.disabled.tooltip"
                        role="img"
                    ></span>
                }
            </agpr-checkbox>

            @if (hasMonitoring && hasSubscriptions) {
                <agpr-quota-preferences
                    [quotaType]="monitoringQuotaTypes.MEDIA_SUBSCRIPTION"
                ></agpr-quota-preferences>
            }

            @if (hasSubscriptions && licenses) {
                <div class="agpr-monitoring-preferences-subscriptions-licenses agpr-columns checkbox">
                    <agpr-checkbox
                        id="monitoringPreferences_twitterSubscription_checkbox"
                        [(ngModel)]="licenses[licensesEnum.TWITTER]"
                        [disabled]="disableInputs || lockSubscriptions"
                        label="AMT.subscriptions.licenses.twitter"
                        [binary]="true"
                    ></agpr-checkbox>
                    <agpr-checkbox
                        id="monitoringPreferences_facebookSubscription_checkbox"
                        [(ngModel)]="licenses[licensesEnum.FACEBOOK]"
                        [disabled]="disableInputs || lockSubscriptions"
                        label="AMT.subscriptions.licenses.facebook"
                        [binary]="true"
                    ></agpr-checkbox>
                </div>
                <div class="agpr-monitoring-preferences-subscriptions-licenses agpr-columns checkbox">
                    <agpr-checkbox
                        id="monitoringPreferences_instagramSubscription_checkbox"
                        [(ngModel)]="licenses[licensesEnum.INSTAGRAM]"
                        [disabled]="disableInputs || lockSubscriptions"
                        label="AMT.subscriptions.licenses.instagram"
                        [binary]="true"
                    ></agpr-checkbox>
                    <agpr-checkbox
                        id="monitoringPreferences_youtubeSubscription_checkbox"
                        [(ngModel)]="licenses[licensesEnum.YOUTUBE]"
                        [disabled]="disableInputs || lockSubscriptions"
                        label="AMT.subscriptions.licenses.youtube"
                        [binary]="true"
                    ></agpr-checkbox>
                </div>
                <div class="agpr-monitoring-preferences-subscriptions-licenses agpr-columns checkbox">
                    <div>
                        <!-- This checkbox is always disabled and mirrors the broadcast-preferences setting -->
                        <agpr-checkbox
                            id="monitoringPreferences_broadcastsSubscription_checkbox"
                            [(ngModel)]="licenses[licensesEnum.TVEYES]"
                            [disabled]="true"
                            label="AMT.subscriptions.licenses.broadcasts"
                            [binary]="true"
                        ></agpr-checkbox>
                    </div>
                    <agpr-checkbox
                        id="monitoringPreferences_redditSubscription_checkbox"
                        [(ngModel)]="licenses[licensesEnum.REDDIT]"
                        [disabled]="disableInputs || lockSubscriptions"
                        label="AMT.subscriptions.licenses.reddit"
                        [binary]="true"
                    ></agpr-checkbox>
                </div>
                <div class="agpr-monitoring-preferences-subscriptions-licenses agpr-columns checkbox">
                    <div class="agpr-monitoring-preferences-podcast-licenses">
                        <agpr-checkbox
                            id="monitoringPreferences_podcastsSubscription_checkbox"
                            [(ngModel)]="podcastLicenseGroupChecked"
                            [disabled]="disableInputs"
                            label="AMT.subscriptions.licenses.podcasts"
                            [binary]="true"
                            (ngModelChange)="handlePodcastLicenseGroupChanged()"
                        ></agpr-checkbox>
                        @if (podcastLicenseGroupChecked) {
                            <div class="agpr-monitoring-preferences-podcast-licenses-expanded">
                                <agpr-radio
                                    [id]="'monitoringPreferences_podcastsSubscription_radio_all'"
                                    [(ngModel)]="podcastLicenseGroup"
                                    label="AMT.subscriptions.licenses.podcasts.all"
                                    [value]="tvEyesPodcastLicenseGroup.ALL_PODCASTS"
                                    (ngModelChange)="calculatePodcastLicenseFromPodcastDisplayGroup()"
                                ></agpr-radio>
                                <agpr-radio
                                    [id]="'monitoringPreferences_podcastsSubscription_radio_financial_only'"
                                    label="AMT.subscriptions.licenses.podcasts.financialOnly"
                                    [(ngModel)]="podcastLicenseGroup"
                                    [value]="tvEyesPodcastLicenseGroup.FINANCIAL_PODCASTS_ONLY"
                                    (ngModelChange)="calculatePodcastLicenseFromPodcastDisplayGroup()"
                                ></agpr-radio>
                            </div>
                        }
                    </div>
                </div>
            }
        </agpr-panel>

        @if (hasMonitoring) {
            <agpr-panel
                header="AMT.prominence"
                [marginTop]="20"
            >
                <div class="agpr-columns">
                    <div class="agpr-column">
                        <agpr-number-input
                            id="prominenceGroupLimit.input"
                            [(ngModel)]="monitoringConfigs.prominenceGroupLimit"
                            [disabled]="isReadOnly"
                            label="AMT.prominence.subjects"
                            tooltip="AMT.prominence.subjectsTooltip"
                            [integerOnly]="true"
                            (blur)="prominenceInUse = 0"
                            [min]="0"
                            [max]="100"
                        ></agpr-number-input>
                        @if (prominenceInUse > 0) {
                            <agpr-form-message [marginBottom]="5">
                                {{ 'AMT.errors.hasProminenceLimitError' | localize : { count: prominenceInUse } }}
                            </agpr-form-message>
                        }
                    </div>
                </div>
            </agpr-panel>
        }

        <agpr-panel header="AMT.mentions">
            <h5 class="agpr-headerH3-dark">
                {{ 'AMT.mentionSavingQuota' | localize }}
            </h5>
            <div class="agpr-monitoring-preferences-mentionWrapper">
                <div class="agpr-monitoring-preferences-mentionSaving-currentPeriod">
                    <span class="agpr-monitoring-preferences-mentionSaving-currentPeriodLabel">
                        {{ 'AMT.mentionSavingQuota.currentPeriod' | localize }}:
                    </span>
                    {{ monitoringConfigs.savingQuotaStart | changeTimeZone: 'UTC' : 'MMMM DD, YYYY' }}
                    - {{ monitoringConfigs.savingQuotaEnd | changeTimeZone: 'UTC' : 'MMMM DD, YYYY' }}
                </div>
                <div class="agpr-columns">
                    <agpr-number-input
                        id="monitoringPreferences_monthlyMentionSavingLimit_numberInput"
                        label="AMT.mentionSavingQuota.monthlyMentionSaveingLimit"
                        tooltip="AMT.mentionSavingQuota.monthlyMentionSaveingLimit.tooltip"
                        [min]="-1"
                        [max]="2000000000"
                        [defaultValue]="0"
                        [integerOnly]="true"
                        [(ngModel)]="monitoringConfigs.savingQuota"
                        (change)="updateSavingQuotaRemaining()"
                        [disabled]="isReadOnly"
                    ></agpr-number-input>
                    <agpr-number-input
                        id="monitoringPreferences_additionalMentions_numberInput"
                        label="AMT.mentionSavingQuota.additionalMentions"
                        tooltip="AMT.mentionSavingQuota.additionalMentions.tooltip"
                        [min]="0"
                        [max]="2000000000"
                        [defaultValue]="0"
                        [integerOnly]="true"
                        [(ngModel)]="monitoringConfigs.additionalMentionQuota"
                        (change)="updateSavingQuotaRemaining()"
                        [disabled]="isReadOnly"
                    ></agpr-number-input>
                    <agpr-number-input
                        id="monitoringPreferences_usedSavedMentions_numberInput"
                        label="AMT.mentionSavingQuota.usedSavedMentions"
                        [(ngModel)]="monitoringConfigs.savingQuotaUsed"
                        [disabled]="true"
                    ></agpr-number-input>
                    <agpr-number-input
                        id="monitoringPreferences_remainingSavedMentions_numberInput"
                        label="AMT.mentionSavingQuota.remainingSavedMentions"
                        [(ngModel)]="monitoringConfigs.savingQuotaRemaining"
                        [disabled]="true"
                    ></agpr-number-input>
                </div>
            </div>

            @if (hasMonitoring) {
                <h5 class="agpr-headerH3-dark">
                    {{ 'AMT.mentionImport' | localize }}
                </h5>
                <div class="agpr-monitoring-preferences-mentionWrapper">
                    <ul
                        class="agpr-columns checkbox"
                        aria-labelledby="mentionImport_heading"
                    >
                        <agpr-checkbox
                            [id]="'monitoringPreferences_mentionImport_csv'"
                            label="AMT.mentionImport.csv"
                            [binary]="true"
                            [(ngModel)]="mentionImportTypes[mentionImportTypesEnum.GENERIC_CSV]"
                            [disabled]="isReadOnly"
                        ></agpr-checkbox>
                        <agpr-checkbox
                            [id]="'monitoringPreferences_mentionImport_cision'"
                            label="AMT.mentionImport.cision"
                            [binary]="true"
                            [(ngModel)]="mentionImportTypes[mentionImportTypesEnum.CISION]"
                            [disabled]="isReadOnly"
                        ></agpr-checkbox>
                        <agpr-checkbox
                            [id]="'monitoringPreferences_mentionImport_meltwater'"
                            label="AMT.mentionImport.meltwater"
                            [binary]="true"
                            [(ngModel)]="mentionImportTypes[mentionImportTypesEnum.MELTWATER]"
                            [disabled]="isReadOnly"
                        ></agpr-checkbox>
                        <agpr-checkbox
                            [id]="'monitoringPreferences_mentionImport_newsdesk'"
                            label="AMT.mentionImport.newsdesk"
                            [binary]="true"
                            [(ngModel)]="mentionImportTypes[mentionImportTypesEnum.NEWSDESK]"
                            [disabled]="isReadOnly"
                        ></agpr-checkbox>
                    </ul>
                </div>
            }
            <agpr-unsaved-export-preferences></agpr-unsaved-export-preferences>
        </agpr-panel>



        @if (hasMonitoring) {
            <agpr-briefing-config-preferences></agpr-briefing-config-preferences>
        }

        @if (hasMonitoring && enableAiFeatures) {
            <agpr-panel header="AMT.aiFeatures">
                <ul attr.aria-labelledby="aiFeatures_heading">
                    <li class="agpr-aiFeatures-types">
                        <agpr-checkbox
                            [id]="'monitoringPreferences_mentions_insights'"
                            label="AMT.aiFeatures.hasMentionInsights"
                            [infoCircleTooltip]="'AMT.aiFeatures.hasMentionInsights.tooltip'"
                            [binary]="true"
                            [(ngModel)]="monitoringConfigs.hasMentionInsights"
                            (onChange)="handleMentionInsightChange()"
                            [disabled]="isReadOnly"
                        ></agpr-checkbox>
                    </li>
                    @if (monitoringConfigs.hasMentionInsights) {
                        <li class="agpr-aiFeatures-types">
                            <agpr-checkbox
                                [id]="'briefingPreferences_insightAutoGenerationBriefings'"
                                label="AMT.aiFeatures.insightAutoGenerationBriefings"
                                [infoCircleTooltip]="'AMT.aiFeatures.insightAutoGenerationBriefings.tooltip'"
                                [binary]="true"
                                [(ngModel)]="briefingConfigs.insightAutoGenerationBriefings"
                                [disabled]="isReadOnly"
                            ></agpr-checkbox>
                        </li>
                    }

                    <li class="agpr-aiFeatures-types">
                        <agpr-checkbox
                            [id]="'monitoringPreferences_coverage_insights'"
                            label="AMT.aiFeatures.hasCoverageInsights"
                            [infoCircleTooltip]="'AMT.aiFeatures.hasCoverageInsights.tooltip'"
                            [binary]="true"
                            [(ngModel)]="monitoringConfigs.hasCoverageInsights"
                            [disabled]="isReadOnly"
                        ></agpr-checkbox>
                    </li>
                </ul>

                <!-- The pool every automation agent on the account draws from. Provisioned through
                     the Enable Agentic AI Features permission, so it only appears alongside it. -->
                @if (hasAutomationAgents) {
                    <h5 class="agpr-headerH3-dark">
                        {{ 'AMT.automationAgentQuota' | localize }}
                        <!-- Provisioned by the account's Agentic AI Features flag, not here -->
                        <span
                            class="agpr-mentionLinks-info fa-regular fa-circle-info"
                            agprTooltip="AMT.automationAgentQuota.tooltip"
                            role="img"
                        ></span>
                    </h5>
                    <div class="agpr-monitoring-preferences-mentionWrapper">
                        @if (automationAgentQuota.windowStart) {
                            <div class="agpr-monitoring-preferences-mentionSaving-currentPeriod">
                                <span class="agpr-monitoring-preferences-mentionSaving-currentPeriodLabel">
                                    {{ 'AMT.automationAgentQuota.currentPeriod' | localize }}:
                                </span>
                                {{ automationAgentQuota.windowStart | changeTimeZone: 'UTC' : 'MMMM DD, YYYY' }}
                                - {{ automationAgentQuota.nextResetDate | changeTimeZone: 'UTC' : 'MMMM DD, YYYY' }}
                            </div>
                        } @else {
                            <agpr-message [severity]="messageSeverityEnum.info">
                                {{ 'AMT.automationAgentQuota.notProvisioned' | localize }}
                            </agpr-message>
                        }
                        <!--
                            (ngModelChange) rather than (change): the input clamps to max on blur,
                            after the native change event has been and gone, and its own `changes`
                            output fires before the model is written - both leave Remaining holding
                            the value the admin typed
                        -->
                        <div class="agpr-columns">
                            <agpr-number-input
                                id="monitoringPreferences_automationAgentMonthlyQuota_numberInput"
                                label="AMT.automationAgentQuota.monthlyQuota"
                                tooltip="AMT.automationAgentQuota.monthlyQuota.tooltip"
                                [min]="0"
                                [max]="2000000000"
                                [defaultValue]="0"
                                [integerOnly]="true"
                                [(ngModel)]="automationAgentQuota.monthlyLimit"
                                (ngModelChange)="updateAutomationAgentQuotaRemaining()"
                                [disabled]="isReadOnly"
                            ></agpr-number-input>
                            <agpr-number-input
                                id="monitoringPreferences_automationAgentAdditionalQuota_numberInput"
                                label="AMT.automationAgentQuota.additionalQuota"
                                tooltip="AMT.automationAgentQuota.additionalQuota.tooltip"
                                [min]="0"
                                [max]="2000000000"
                                [defaultValue]="0"
                                [integerOnly]="true"
                                [(ngModel)]="automationAgentQuota.additionalQuota"
                                (ngModelChange)="updateAutomationAgentQuotaRemaining()"
                                [disabled]="isReadOnly"
                            ></agpr-number-input>
                            <agpr-number-input
                                id="monitoringPreferences_automationAgentUsedQuota_numberInput"
                                label="AMT.automationAgentQuota.usedQuota"
                                [(ngModel)]="automationAgentQuota.count"
                                [disabled]="true"
                            ></agpr-number-input>
                            <agpr-number-input
                                id="monitoringPreferences_automationAgentRemainingQuota_numberInput"
                                label="AMT.automationAgentQuota.remainingQuota"
                                [(ngModel)]="automationAgentQuota.remaining"
                                [disabled]="true"
                            ></agpr-number-input>
                        </div>
                    </div>
                }
            </agpr-panel>
        }
        <!-- Available for accounts with Media Monitoring APIs provisioned -->
        @if (hasMonitoring && hasMediaMonitoringApis) {
            <agpr-panel header="AMT.mediaMonitoringApi">
                @if (!hasApiKeyManagers) {
                    <agpr-message [severity]="messageSeverityEnum.warning">
                        {{ 'AMT.mediaMonitoringApi.noApiKeyManagers' | localize }}
                    </agpr-message>
                }
                @if (apiKeys.length) {
                    <ul
                        class="agpr-monitoring-preferences-mediaMonitoringApis-apiKeyList"
                        agprListKeyboardNavigation
                        [list]="apiKeys"
                        [attr.aria-labelledby]="'mediaMonitoringApi_heading'"
                    >
                        @for (apiKey of apiKeys; track apiKey.id; let i = $index) {
                            <li class="agpr-monitoring-preferences-mediaMonitoringApis-apiKeyListItem agpr-contextMenu-parent">
                                <agpr-media-monitoring-api-key-card
                                    [id]="'monitoringPreferences_mediaMonitoringApiKeyCard_' + i"
                                    [apiKey]="apiKey"
                                ></agpr-media-monitoring-api-key-card>
                                <div class="agpr-contextMenu bottom right">
                                    @if (!isReadOnly) {
                                        <agpr-button
                                            [id]="'monitoringPreferences_mediaMonitoringApiKeyCard_' + i + (apiKey.disabled ? 'activate' : 'suspend')"
                                            class="agpr-monitoring-preferences-mediaMonitoringApis-apiKeyListItem-button"
                                            [style]="buttonTypes.contextMenu"
                                            [icon]="apiKey.disabled ? 'fa-duotone fa-regular fa-play' : 'fa-duotone fa-regular fa-pause'"
                                            [tooltip]="apiKey.disabled ? 'AMT.mediaMonitoringApi.activate' : 'AMT.mediaMonitoringApi.suspend'"
                                            [tooltipPosition]="'top'"
                                            (click)="updateApiKeyStatus(apiKey)"
                                        ></agpr-button>
                                    }
                                </div>
                            </li>
                        }
                    </ul>
                } @else {
                    <agpr-message [severity]="messageSeverityEnum.noContent">
                        {{ 'AMT.mediaMonitoringApi.noApiKeys' | localize }}
                    </agpr-message>
                }
            </agpr-panel>
        }
    </div>
}
